import { render, staticRenderFns } from "./public-top.vue?vue&type=template&id=15c90367&scoped=true&"
import script from "./public-top.vue?vue&type=script&lang=js&"
export * from "./public-top.vue?vue&type=script&lang=js&"
import style0 from "./public-top.vue?vue&type=style&index=0&id=15c90367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c90367",
  null
  
)

export default component.exports